<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<mat-sidenav-container dir="ltr" class="light-theme blue_theme">
  <router-outlet></router-outlet>
</mat-sidenav-container>